/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminMarketplaceType,
    AdminMarketplaceTypeFromJSON,
    AdminMarketplaceTypeFromJSONTyped,
    AdminMarketplaceTypeToJSON,
} from './AdminMarketplaceType';
import {
    AdminProductStatus,
    AdminProductStatusFromJSON,
    AdminProductStatusFromJSONTyped,
    AdminProductStatusToJSON,
} from './AdminProductStatus';
import {
    ProductConsistency,
    ProductConsistencyFromJSON,
    ProductConsistencyFromJSONTyped,
    ProductConsistencyToJSON,
} from './ProductConsistency';

/**
 * 
 * @export
 * @interface AdminProductListFilter
 */
export interface AdminProductListFilter {
    /**
     * BrokenLink keeps products with a live listing whose link no longer leads to it.
     * @type {boolean}
     * @memberof AdminProductListFilter
     */
    brokenLink?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminProductListFilter
     */
    categoryIDs?: Array<number>;
    /**
     * 
     * @type {Array<ProductConsistency>}
     * @memberof AdminProductListFilter
     */
    consistency?: Array<ProductConsistency>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminProductListFilter
     */
    consistencyDetails?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProductListFilter
     */
    duplicates?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminProductListFilter
     */
    groupSaleIDs?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AdminProductListFilter
     */
    limit?: number;
    /**
     * 
     * @type {Array<AdminMarketplaceType>}
     * @memberof AdminProductListFilter
     */
    marketplace?: Array<AdminMarketplaceType>;
    /**
     * 
     * @type {number}
     * @memberof AdminProductListFilter
     */
    offset?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminProductListFilter
     */
    palletOrderIDs?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof AdminProductListFilter
     */
    search?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProductListFilter
     */
    showSold?: boolean;
    /**
     * 
     * @type {Array<AdminProductStatus>}
     * @memberof AdminProductListFilter
     */
    status?: Array<AdminProductStatus>;
}

export function AdminProductListFilterFromJSON(json: any): AdminProductListFilter {
    return AdminProductListFilterFromJSONTyped(json, false);
}

export function AdminProductListFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductListFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brokenLink': !exists(json, 'brokenLink') ? undefined : json['brokenLink'],
        'categoryIDs': !exists(json, 'categoryIDs') ? undefined : json['categoryIDs'],
        'consistency': !exists(json, 'consistency') ? undefined : ((json['consistency'] as Array<any>).map(ProductConsistencyFromJSON)),
        'consistencyDetails': !exists(json, 'consistencyDetails') ? undefined : json['consistencyDetails'],
        'duplicates': !exists(json, 'duplicates') ? undefined : json['duplicates'],
        'groupSaleIDs': !exists(json, 'groupSaleIDs') ? undefined : json['groupSaleIDs'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'marketplace': !exists(json, 'marketplace') ? undefined : ((json['marketplace'] as Array<any>).map(AdminMarketplaceTypeFromJSON)),
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'palletOrderIDs': !exists(json, 'palletOrderIDs') ? undefined : json['palletOrderIDs'],
        'search': !exists(json, 'search') ? undefined : json['search'],
        'showSold': !exists(json, 'showSold') ? undefined : json['showSold'],
        'status': !exists(json, 'status') ? undefined : ((json['status'] as Array<any>).map(AdminProductStatusFromJSON)),
    };
}

export function AdminProductListFilterToJSON(value?: AdminProductListFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brokenLink': value.brokenLink,
        'categoryIDs': value.categoryIDs,
        'consistency': !value.consistency ? undefined : ((value.consistency as Array<any>).map(ProductConsistencyToJSON)),
        'consistencyDetails': value.consistencyDetails,
        'duplicates': value.duplicates,
        'groupSaleIDs': value.groupSaleIDs,
        'limit': value.limit,
        'marketplace': !value.marketplace ? undefined : ((value.marketplace as Array<any>).map(AdminMarketplaceTypeToJSON)),
        'offset': value.offset,
        'palletOrderIDs': value.palletOrderIDs,
        'search': value.search,
        'showSold': value.showSold,
        'status': !value.status ? undefined : ((value.status as Array<any>).map(AdminProductStatusToJSON)),
    };
}

